import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { PageLayout } from "../components/page-layout";

// Landing page for Auth0's post-verification redirect. Auth0 appends `success` and
// `message` query params to the tenant's Redirect To URL after the user clicks the
// link in a verification email. Anything other than success=true (including someone
// typing the URL with no params at all) renders the failure branch. The failure CTA
// doubles as the resend mechanism: the Auth0 post-login action re-sends a fresh
// verification email whenever an unverified user attempts to log in.
export const EmailVerifiedPage: React.FC = () => {
  const { loginWithRedirect } = useAuth0();
  const [searchParams] = useSearchParams();

  const isSuccess = searchParams.get("success") === "true";
  const failureMessage =
    searchParams.get("message") || "This verification link didn't work.";

  const handleLogIn = () =>
    loginWithRedirect({
      appState: { returnTo: "/dashboard" },
      authorizationParams: { prompt: "login" },
    });

  return (
    <PageLayout>
      <div className="email-verification-error">
        <div className="email-verification-error__card">
          <h1 className="email-verification-error__title">
            {isSuccess ? "Email verified" : "Verification unsuccessful"}
          </h1>
          <p className="email-verification-error__lead">
            {isSuccess
              ? "Your email address has been verified — your account is ready to use."
              : failureMessage}
          </p>
          <div className="email-verification-error__actions">
            <button
              type="button"
              className="email-verification-error__cta"
              onClick={handleLogIn}
            >
              Log in
            </button>
          </div>
          {!isSuccess && (
            <p className="email-verification-error__note">
              If your email still needs verifying, logging in again automatically
              sends you a fresh verification link.
            </p>
          )}
        </div>
      </div>
    </PageLayout>
  );
};
